import { render, staticRenderFns } from "./WarehouseCard.vue?vue&type=template&id=1c8e7747&functional=true"
import script from "./WarehouseCard.vue?vue&type=script&lang=js"
export * from "./WarehouseCard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseCard.vue?vue&type=style&index=0&id=1c8e7747&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports